import { APIPath } from '../constant'
import { CommonUtility } from '../common'
import { BaseService } from './base'

// Staff-only Super Admin reads. Same transport as the rest of the site:
// GET, query string, X-TOKEN / app / X-LoginSource / X-Recaptcha from BaseService.
// List bodies are { Items, TotalCount }, the same shape as Companies.
class SuperAdminDashboard {
    getOverview(periodDays = 30) {
        return BaseService.get(
            `${APIPath.superAdminOverview}?${CommonUtility.objectToParams({
                PeriodDays: periodDays,
            })}`,
        )
    }

    listCompanies({
        pageNumber = 1,
        pageSize = 8,
        search = '',
        status = 'All',
        sort = 'templates',
        sortDir = 'desc',
    } = {}) {
        return BaseService.get(
            `${APIPath.superAdminCompanies}?${CommonUtility.objectToParams({
                PageNumber: pageNumber,
                PageSize: pageSize,
                Search: search,
                Status: status,
                Sort: sort,
                SortDir: sortDir,
            })}`,
        )
    }

    listSignIns({
        periodDays = 7,
        pageNumber = 1,
        pageSize = 8,
        search = '',
    } = {}) {
        return BaseService.get(
            `${APIPath.superAdminSignIns}?${CommonUtility.objectToParams({
                PeriodDays: periodDays,
                PageNumber: pageNumber,
                PageSize: pageSize,
                Search: search,
            })}`,
        )
    }

    listWatchlist({
        breach = 'All',
        pageNumber = 1,
        pageSize = 8,
        search = '',
    } = {}) {
        return BaseService.get(
            `${APIPath.superAdminWatchlist}?${CommonUtility.objectToParams({
                Breach: breach,
                PageNumber: pageNumber,
                PageSize: pageSize,
                Search: search,
            })}`,
        )
    }
}

const SuperAdminDashboardService = new SuperAdminDashboard()
Object.freeze(SuperAdminDashboardService)
export { SuperAdminDashboardService }
